<template>
    <div class="product-creator flex justify-center items-center w-full max-w-screen-xl h-full mx-auto px-6 py-12">
        <div class="w-2/3 grid grid-cols-3 gap-16">

            <div v-for="template in templates" :key="template.key">
                <div class="h-36 w-full mb-8 bg-contain bg-center bg-no-repeat" :style="{ backgroundImage: 'url(' + template.primary_image.path + ')' }"></div>
                <div class="mb-12 text-center">{{ template.name }}</div>
                <Button class="w-full" @click="select(template.id)">
                    {{ __('home::orders.select') }} 
                    <ChevronRightIcon class="h-4 w-4 ml-2" />
                </Button>
            </div>

        </div>   
    </div> 
</template>

<script>
    import axios from 'axios'
    import collect from 'collect.js'

    import {
        ChevronRightIcon,
    } from '@heroicons/vue/outline'

    export default {
        components: {
            ChevronRightIcon,
        },
        props: {
            template: String|Number,
            order: Object,
            products: Object,
        },
        data() {
            return {
                templates: collect(this.products)
                    .where('category', 'multiple')
                    .where('shape', this.order.meta.shape)
                    .all(),
            }
        },
        methods: {
            select(template) {
                let request = {
                    template: template,
                };

                axios
                    .patch(this.$route('home::orders.update', { uuid: this.order.uuid }), request)
                    .then((res) => {
                        this.$emit('update:template', template);
                    });
            },
        },
    }
</script>